// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuLink_link__NoPii","current":"MenuLink_current__yEpuy","liItem":"MenuLink_liItem__gug0_"};